import Box from "@mui/material/Box";
import { homeDivider } from "styles/home_page/divider";

export default function HomeDivider(){
    return (
        <Box sx={homeDivider}></Box>
    )
}